import React from 'react';
import { Field } from 'react-final-form';

import TextFieldInput from '../utils/TextFieldInput';

const TextField = React.memo( ( {
  field, validate, value, name, ...rest
} ) => {
  if ( field ) {
    return (
      <Field name={field} validate={validate}>
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && meta.submitError );

          return (
            <TextFieldInput
              {...input}
              {...rest}
              value={input.value || ''}
              inputOnChange={input.onChange}
              inputName={input.name}
              focused={meta.active}
              meta={meta}
              isInvalid={isInvalid}
            />
          );
        }}
      </Field>
    );
  }
  return (
    <TextFieldInput
      {...rest}
      value={value || ''}
      inputName={name}
    />
  );
} );

export default TextField;
